// import request from '../utils/requset';
import request from '../request/http';


const up = {

    //乡村用户导入模版下载
    downloadModel(data) {
        return request.post('/service-app/file/downloadModel', data)
    },
    //乡村用户导入模版上传
    uploadModel(data) {
        return request.post('/service-app/file/uploadModel',data)
    },
 //通用下载模版接口
     downloadFileModel(data) {
        //hemei-admin/file/downloadModel?fileCode=village_genealogy_model
        // 这个接口，你把后面的 fileCode 字段换下就行
        return request.get(`/hemei-admin/file/downloadModel?fileCode=${data.fileCode}`)
    },


}

export default up;